import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { ENV_APP_PROJECT } from '@apps-common/lib/environment'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IAuthActionResponse, IAuthLoginResponse, ILoginModel } from '@apps-common/types/auth'

const project = ENV_APP_PROJECT

export const login = async (model: ILoginModel): Promise<IAuthLoginResponse> => {
  const url = project === 'my-monitoring' ? '/my-monitoring/account/Login' : '/account/Login'

  return axios.post(url, model).then((res) => ({
    result: res?.data?.result,
    message: res?.data?.msg,
    id: res?.data?.id,
    token: res?.data?.token,
    expiresIn: res?.data?.expiresIn
  }))
}

type Props = {
  model: ILoginModel
}

export const useLogin = (
  notify?: boolean,
  onSuccess?: (data: IAuthActionResponse, variables: Props['model']) => void,
  onFailure?: ({ model }: Props) => void
) =>
  useMutation({
    mutationKey: ['login'],
    mutationFn: ({ model }: Props) => login(model),
    onSuccess: (data, variables) => {
      if (onSuccess) {
        onSuccess(data, variables.model)
      }
      if (notify) {
        toastSuccess(data?.message || 'Login successful.')
      }
    },
    onError: (error, variables) => {
      if (onFailure) {
        onFailure(variables)
      }
      if (notify) {
        toastError(error?.message || 'Login failed.')
      }
    },
    throwOnError: false
  })
